import { CreditCardOutlined, WarningOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import React from 'react'

export default function PaymentMethodSection() {
    return (
        <div style={{
            border: '1px solid #e2e4e9',
            borderRadius: 6,
            marginBottom: 16
        }}>
            <div
                style={{
                    borderBottom: '1px solid #e2e4e9',
                    padding: 8,
                    background: '#f0f2f44d',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                }}
            >
                <CreditCardOutlined />
                <span style={{
                    fontWeight: 600,
                    fontFamily: 'tradeGothic',
                    fontSize: 14
                }}>
                    Payment Methods
                </span>
                <Tag color='orange' style={{ fontFamily: 'tradeGothic' }}>Will not be merged</Tag>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: 8 }}>
                <WarningOutlined style={{ paddingTop: 4, color: '#d46b08' }} />
                <span style={{
                    color: '#d46b08',
                    fontFamily: 'tradeGothic'
                }}>
                    Payment methods cannot be merged between profiles for security reasons.
                    The surviving profile's payment methods will be retained.
                </span>

            </div>
        </div>
    )
}
